module.exports = __webpack_public_path__ + "img/header-bg.08f3f42c.png";